import React from 'react'
import { format } from "date-fns";
import { Thead, Tbody, Tr, Td, Input, Text, Box, Center } from "@chakra-ui/react";
import { Table} from "@chakra-ui/react";
import { BiServer } from "react-icons/all";
import "./TouristTempleReport.css";
import { touristEachTempleColumn } from '../../../constants/tableData';

function TouristEachTempleReportTable({data, filter}) {
  return (
    <>
        <Box style={{ position: "sticky", left: "0"}} w="100%" mb="10px">
            <Text textAlign="center" fontSize="25px" fontWeight="bold">Tourist at Each Temple</Text>
            <Text textAlign="center">Date: {format(new Date(filter.dateFrom), "dd MMMM")} to {format(new Date(filter.dateFrom), "dd MMMM yyyy")}</Text>
        </Box>
        {data?.length > 0 ? (
            <Table w="5100px" size="sm" className="temple-report-table" borderRight="1px solid black">
                <Thead className='temple-report-thead'>
                    <Tr color="#4149BE" className='temple-report-thead-tr1' fontWeight="bold" textAlign="center" h="35px" >
                        <Td textAlign="center" p="0" bgColor='#4F81BD'>No.</Td>
                        <Td textAlign="center" p="0">Date</Td>
                        <Td textAlign="center" p="0">Hour</Td>
                        <Td textAlign="center" p="0">NATIONALITY</Td>
                        <Td textAlign="center" p="0">ANGKOR WAT WEST</Td>
                        <Td textAlign="center" p="0">ANGKOR WAT EAST</Td>
                        <Td textAlign="center" p="0">BAKHENG</Td>
                        <Td textAlign="center" p="0">BAYON WEST</Td>
                        <Td textAlign="center" p="0">BAYON EAST</Td>
                        <Td textAlign="center" p="0">BAYON NORTH</Td>
                        <Td textAlign="center" p="0">BAYON SOUTH</Td>
                        <Td textAlign="center" p="0">TA PROHM WEST</Td>
                        <Td textAlign="center" p="0">TA PROHM EAST</Td>
                        <Td textAlign="center" p="0">TA PROHM NORTH</Td>
                        <Td textAlign="center" p="0">BANTEAY KDEI WEST</Td>
                        <Td textAlign="center" p="0">BANTEAY KDEI EAST</Td>
                        <Td textAlign="center" p="0">KRAVAN</Td>
                        <Td textAlign="center" p="0">TA NEI</Td>
                        <Td textAlign="center" p="0">TAKEO</Td>
                        <Td textAlign="center" p="0">PREAH KHAN WEST</Td>
                        <Td textAlign="center" p="0">PREAH KHAN EAST</Td>
                        <Td textAlign="center" p="0">PREAH KHAN NORTH</Td>
                        <Td textAlign="center" p="0">NEAK PEAN</Td>
                        <Td textAlign="center" p="0">TA SOM</Td>
                        <Td textAlign="center" p="0">PRE RUP EAST</Td>
                        <Td textAlign="center" p="0">PRE RUP SOUTH</Td>
                        <Td textAlign="center" p="0">MEBON</Td>
                        <Td textAlign="center" p="0">BANTEAY SAMRE</Td>
                        <Td textAlign="center" p="0">BAKONG WEST</Td>
                        <Td textAlign="center" p="0">BAKONG EAST</Td>
                        <Td textAlign="center" p="0">LOLEI</Td>
                        <Td textAlign="center" p="0">PREAH KO</Td>
                        <Td textAlign="center" p="0">BANTEAY SREI</Td>
                        <Td textAlign="center" p="0">KBAL SPEAN</Td>
                        <Td textAlign="center" p="0">PHNOM KROM</Td>
                        <Td textAlign="center" p="0">WAT ATHWEA</Td>
                        <Td textAlign="center" p="0">BENG MEALEA</Td>
                    </Tr>
                </Thead>

                <Tbody>
                    {data?.map((val, index) =>  {
                        return (
                            <Tr key={index} h="25px">
                                {touristEachTempleColumn.map((item, i) => {
                                    return (
                                        <Td 
                                            key={i} 
                                            w={item.columnId === "n" ? "40px" : item.columnId === 'nationality' ? "180px" : "80px"} 
                                            py="0" 
                                            p="1"
                                            bg={(index===data.length-1) && "#8497b0 !important"} 
                                            color={(index===data.length-1) ? "white !important" : "black" } 
                                        >
                                            <Input
                                                padding="2px"
                                                width="100%"
                                                height="23px"
                                                textAlign="center"
                                                borderColor='gray.300'
                                                type={item.type}
                                                className={`tourist-each-temple-${item.columnId} ${item.columnId ? "is-disable-input" : ""}`}
                                                id={`tourist-each-temple-${item.columnId}-${val.id}`}
                                                defaultValue={val[item.columnId]}
                                                // onKeyUp={() => _calcNum(`${data.id}`)}
                                            />
                                        </Td>
                                    )
                                })}
                            </Tr>
                        )
                    })}
                </Tbody>
            </Table>
        ) : (
            <Center py="3" w="full" h="70vh" color="gray.400">
                <BiServer size="1.3rem" /> <Text fontSize="md">&nbsp;No data.</Text>
            </Center>
        )}
    </>
  )
}

export default TouristEachTempleReportTable
